import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = {
  class: "mt-4 rounded-lg border border-lightGray30 p-4 text-left",
  "data-testid": "schedule-requirements-formation"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Exigir nível de formação na escala", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1 text-sm text-[#68688D]" }, " Ao ativar, as regras da política de pagamento podem variar conforme a formação do médico. ", -1)
const _hoisted_6 = {
  key: 0,
  class: "mt-6 border-t border-gray-200 pt-6",
  "data-testid": "schedule-requirements-qualification"
}
const _hoisted_7 = {
  key: 0,
  class: "mt-2 text-sm text-negative text-left",
  "data-testid": "schedule-requirements-qualification-error"
}

import { ref, onMounted, inject } from 'vue'
import DsSwitch from '@/components/designSystem/Switch/index.vue'
import { useCreateScheduleStore } from '@/pinia-store/useCreateScheduleStore'
import { storeToRefs } from 'pinia'
import ComboBoxWithOther from './ComboBoxWithOther.vue'
import FieldOptionsService from '@/Network/Services/FieldOptionsService'
import QualificationRequirementSection from '@/components/QualificationRequirement/QualificationRequirementSection.vue'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { useErrorToast } from '@/composables/useErrorToast'
import { SCHEDULE_SECTION_LABELS } from '@/constants/schedule-sections.constants'
import ScheduleStepHeading from './ScheduleStepHeading.vue'

type Item = { title: string; value: number }


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleRequirements',
  props: {
    errors: {},
    onClearError: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const store = (inject('createScheduleStore') ?? useCreateScheduleStore()) as ReturnType<
  typeof useCreateScheduleStore
>
const { step2, stepQualificationRequirement } = storeToRefs(store)
const { flags } = useFeatureFlags()

const positions = ref<Item[]>([])
const formations = ref<Item[]>([])
const shifts = ref<Item[]>([])

const fieldService = new FieldOptionsService()
const { notifyError } = useErrorToast()

const fetchFieldOptions = async () => {
  try {
    const [positionResponse, shiftsResponse, formationResponse] = await Promise.all([
      fieldService.getPositions(),
      fieldService.getShifts(),
      fieldService.getFormations()
    ])

    positions.value = positionResponse.map((position) => ({
      title: position.name,
      value: position.id
    }))

    formations.value = formationResponse.map((formation) => ({
      title: formation.name,
      value: formation.id
    }))

    shifts.value = shiftsResponse.map((shift) => ({
      title: shift.name,
      value: shift.id
    }))
  } catch (error) {
    notifyError(error, 'Não foi possível carregar as posições, turnos e formações.')
  }
}

onMounted(fetchFieldOptions)

// eslint-disable-next-line @typescript-eslint/no-unused-vars


/** A validade da Qualificação exigida trava o avanço do passo (CreateSchedule). */
function onQualificationValidity(valid: boolean) {
  stepQualificationRequirement.value.isValid = valid
  if (valid) props.onClearError('qualificationPolicy')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ScheduleStepHeading, {
      title: _unref(SCHEDULE_SECTION_LABELS).requirements,
      class: "mb-2"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ComboBoxWithOther, {
        modelValue: _unref(step2).positions,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_unref(step2).positions) = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (props.onClearError('positions')))
        ],
        items: positions.value,
        label: "Selecione as posições da escala",
        error: !!props.errors.positions,
        "error-message": props.errors.positions
      }, null, 8, ["modelValue", "items", "error", "error-message"]),
      _createVNode(ComboBoxWithOther, {
        modelValue: _unref(step2).shifts,
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => ((_unref(step2).shifts) = $event)),
          _cache[3] || (_cache[3] = ($event: any) => (props.onClearError('shifts')))
        ],
        items: shifts.value,
        label: "Selecione os turnos da escala",
        error: !!props.errors.shifts,
        "error-message": props.errors.shifts
      }, null, 8, ["modelValue", "items", "error", "error-message"]),
      _createElementVNode("section", _hoisted_3, [
        _createVNode(DsSwitch, {
          modelValue: _unref(step2).formationRequired,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(step2).formationRequired) = $event)),
          "data-testid": "schedule-requirements-formation-switch"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _hoisted_5,
        (_unref(step2).formationRequired)
          ? (_openBlock(), _createBlock(ComboBoxWithOther, {
              key: 0,
              modelValue: _unref(step2).formations,
              "onUpdate:modelValue": [
                _cache[5] || (_cache[5] = ($event: any) => ((_unref(step2).formations) = $event)),
                _cache[6] || (_cache[6] = ($event: any) => (props.onClearError('formations')))
              ],
              items: formations.value,
              label: "Selecione os níveis de formação da escala",
              error: !!props.errors.formations,
              "error-message": props.errors.formations
            }, null, 8, ["modelValue", "items", "error", "error-message"]))
          : _createCommentVNode("", true)
      ]),
      (_unref(flags).enabledProfessionalDocuments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(QualificationRequirementSection, {
              modelValue: _unref(stepQualificationRequirement).policy,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(stepQualificationRequirement).policy) = $event)),
              onValidityChange: onQualificationValidity
            }, null, 8, ["modelValue"]),
            (props.errors.qualificationPolicy)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(props.errors.qualificationPolicy), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})